var codeblock_default = {
  "blockStyleSpacing": "_6Kxwf",
  "codeBlock": "xdOV2 _6Kxwf",
  "renderedInTable": "dmQ4d"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
